<template>
  <div>
  <header-mx></header-mx>
    <section class="main">
      <div class="figuras">
        <div class="container">
          <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
            <div class="col-sm-12">
              <div class="white row">
                <div class="col-12 text-center">
                  <h1>Términos y condiciones</h1>
                </div>
              </div>
              <div class="row">
                <div class="col-12 white">
                  <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>

                  <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.</p>

                  <p>Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.</p>

                  <p>Nam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</p>

                  <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis.</p>

                  <p>At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, At accusam aliquyam diam diam dolore dolores duo eirmod eos erat, et nonumy sed tempor et et invidunt justo labore Stet clita ea et gubergren, kasd magna no rebum. sanctus sea sed takimata ut vero voluptua. est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <div class="container">
          <div class="row p-2">
            <div class="col-12 text-center">
              <div class="texto">
                <span class="px-1">
                  ConsultoriosMX
                  <sup>&reg;</sup> 2020
                </span>

                <br class="d-block d-md-none" />
                <span class="d-none d-md-inline-block">|</span>
                <router-link
                  to="/terminos-y-condiciones"
                  target="_blank"
                  class="mx-1"
                >&nbsp;Términos y condiciones</router-link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </section>
  </div>
</template>

<script>


import AOS from "aos";
import swal from "sweetalert2";

export default {
  name: "IEEServiciosAcademicos",
  props: {
    msg: String
  },
  data() {
    return {
      tiposervicio: "" 
    };
  },
  mounted: function(){
    AOS.init();
  },
  methods: {
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var userData = {
        nombre: this.nombre,
        apellido: this.apellido,
        email: this.email,
        tel: this.tel,
        no_ticket: this.no_ticket,
        sede: this.sede
      };

      let formData = new FormData();

      formData.append("form_data", JSON.stringify(userData));
      formData.append("cv", this.file);

      console.log("enviando");
      console.log(this.file);
      console.log(JSON.stringify(userData));

    //   this.$http
    //     .post(
    //       "https://www.superbowlexperience.com.mx/upload.php",
    //       //"http://temp-big-game-experience.pautacreativa.mx/upload.php",
    //       formData,
    //       {
    //         emulateJSON: true,
    //         httpsAgent: new https.Agent({ rejectUnauthorized: false }),
    //         headers: {
    //           "Content-Type": "multipart/form-data"
    //           //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
    //         }
    //       }
    //     )
    //     .then(
    //       response => {
    //         // get body data
    //         console.log("envio");
    //         console.log(response);
    //         vm.$store.state.loading = false;
    //         console.log(response.data);
    //         var res = response.data;

    //         if (res.status == "ok") {
    //           this.registro = 1;
    //         } else if (res.status == "notok") {
    //           swal.fire("Oops", res.msg, "warning");
    //         }
    //       },
    //       error => {
    //         // error callback
    //         console.log("error callback");
    //         console.log(error);
    //         vm.$store.state.loading = false;
    //         //console.log(userData);
    //         swal.fire(
    //           "Oops",
    //           "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
    //           "warning"
    //         );
    //       }
    //     );

        this.$router.push('mi-cuenta')


    }
  }
};
</script>

